import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useEffectFn } from '@ngneat/effects-hooks';
import {
  blockStore,
  updateActiveCompanyEffect,
  useGQLBlock,
  useGQLSite,
  useGQLSystem,
  setActiveSite,
  useCompany,
  useActiveAppEntities,
  alertStore,
  setActiveSystem,
} from '@beeriot/api-client';

export function ParamIdHandler() {
  const updateActiveCompany = useEffectFn(updateActiveCompanyEffect);

  const { siteId, lineId, blockId, companyId } = useParams();
  const { activeCompany, activeSite, activeSystem, activeBlock } =
    useActiveAppEntities();
  const urlCompany = useCompany(companyId);
  const urlSite = useGQLSite(siteId);
  const urlSystem = useGQLSystem({ systemId: lineId, isActive: true });
  const urlBlock = useGQLBlock(blockId);

  useEffect(() => {
    if (urlCompany && urlCompany.id !== activeCompany?.id) {
      updateActiveCompany(urlCompany);
    }

    if (urlSite && urlSite.id !== activeSite?.id) {
      setActiveSite(urlSite);
    }

    if (urlSystem && urlSystem.id !== activeSystem?.id) {
      setActiveSystem(urlSystem);
      alertStore.update((s) => ({ ...s, systemIdFilter: urlSystem?.id }));
    }

    if (urlBlock && urlBlock.id !== activeBlock?.id) {
      blockStore.update((state) => ({
        ...state,
        activeBlock: urlBlock,
      }));
    }
  }, [
    urlSystem,
    activeSystem?.id,
    urlSite,
    activeSite?.id,
    urlBlock,
    activeBlock?.id,
    activeCompany?.id,
    companyId,
    updateActiveCompany,
    urlCompany,
  ]);

  return null;
}
